define('app/factories/_b2b_landing_page_factory',['app/setup','app/views/_b2b_landing_page_view'],
  function(takhfifan,_b2bLandingPageView) {
    $('.tkh-b2b-contactForm').each(function(){
      new takhfifan._b2bLandingPageView({
        el: $(this)
      });
    });
});
